module.exports = __webpack_public_path__ + "img/icon_4_47.f42f4185.png";